import { render, staticRenderFns } from "./ErrorLayout.vue?vue&type=template&id=64a6e137&"
import script from "./ErrorLayout.vue?vue&type=script&lang=ts&"
export * from "./ErrorLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports